import { THEMES } from 'src/app/shared/services/theme.service';
import { versions } from './versions';

// to be used
enum hostUrls {
  sunilIP = 'http://192.168.1.202:8080/api',
  poojanIP = 'http://192.168.1.210:8080/api',
  baseProjectURL = 'https://dev.baseprojectjava.thesunflowerlab.com/api',
  dummyURL = 'https://jsonplaceholder.typicode.com',
  hostedURL = 'https://dev.cep.thesunflowerlab.com/api'
}

export const environment = {
  versions,
  production: false,
  hostUrl: '',
  apiUrl: hostUrls.hostedURL,
  persistUserSession: true,
  sentryKey: '', //'https://86sacecc08fb74322b197c4225654ff74@sentry.thesunflowerlab.com/49',
  defaultTheme: window.matchMedia('(prefers-color-scheme: dark)') ? THEMES.DARK : THEMES.LIGHT,
  firebase: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  swUpdate: true,
  swUpdateFooter: true,
  horizontalProfileMenu: false,
  encryptionService: {
    enable: false,
    secretKey: 'BfBRoYxsRKGnx3DlPgnsmei7qVHTD62o',
    secretIV: 'cGsgbxxqbcYN6HZG'
  },
  compressAfterFileSize: 2
};
